import BrandProductDescription from './BrandProductDescription';
export default BrandProductDescription;
